import GameRoleInfo from './GameRoleInfo/'
import Dialog from './Dialog/'
export default {
    install: (app) => {
        Dialog.install(app)
        GameRoleInfo.install(app)
    }
}
